<div
  animate.enter="animate-down"
  animate.leave="animate-up"
  class="w-full min-h-screen rounded-xl flex flex-col items-center justify-center relative"
>
  <div class="-top-4 -left-6 absolute">
    <!-- <button
        [routerLink]="['', 'home']"
        class="bg-gray-100 p-0.5 text-gray-100 rounded-xl"
      >
        <div
          class="py-1.5 pl-2.5 pr-3 bg-white hover:bg-gray-100/50 rounded-xl flex items-center gap-1.5"
        >
          <mat-icon svgIcon="home"></mat-icon>
          {{ "Home" | concat | translate }}
        </div>
      </button> -->
  </div>
  <img src="assets/images/emblem.png" class="w-16 md:w-20" alt="" />
  <span class="text-black text-3xl font-bold mt-5 mb-2">
    <!-- {{ "Log In" | concat | translate }} -->
    Access Your
    <span class="text-primary-600">Meeting</span>
    Space
  </span>
  <p class="text-gray-600">
    <!-- {{ "Login Welcome Note" | concat | translate }} -->
    Enter your GMS Email to start connecting and collaborating securely.
  </p>
  <div class="w-full mt-3">
    <form
      (ngSubmit)="login(form.value)"
      [formGroup]="form"
      autocomplete="off"
      novalidate
    >
      <mat-form-field appearance="outline">
        <mat-label>{{ "Gms Email Address" | concat | translate }}</mat-label>
        <input type="email" matInput formControlName="gmsEmail" />
        <mat-icon matIconPrefix>email</mat-icon>
        <mat-error>
          @if (!form.get('gmsEmail')?.valid && form.get('gmsEmail')?.touched) {
          <span>{{ "Field is required" | concat | translate }}</span>
          }
        </mat-error>
      </mat-form-field>
       <mat-form-field appearance="outline">
        <mat-label>{{
          ("Phone Number" | concat | translate) || "Phone Number"
        }}</mat-label>
        <input type="text" matInput formControlName="phoneNumber" />
        <mat-icon matIconPrefix>phone</mat-icon>
        <mat-error>
          @if(!form.get('phoneNumber')?.valid &&
          form.get('phoneNumber')?.touched){
          <span>
            {{ "Field is required" | concat | translate }}
          </span>
          }
        </mat-error>
      </mat-form-field>


      <div class="w-full mb-3">
        <button
          [disabled]="!form.valid || loading"
          class="w-full"
          mat-raised-button
          color="primary"
        >
          {{ "Sign Up With Gms" | concat | translate }}
        </button>
      </div>
      <div class="w-full mt-2 text-center">
        <p class="text-sm md:text-md text-gray-dark">
             {{ "Do you not have a GMS Address" | concat | translate }}?
          <a routerLink="/auth/register" class="text-primary font-bold">
            {{ "Register Here." | concat | translate }}
          </a>
        </p>
      </div>
    </form>

    <div class="flex flex-col gap-4 w-full py-4 px-2">
      <div class="border border-gray-100 relative mb-4">
        <div class="bg-white w-fit absolute left-[50%] -top-[0.7rem] px-2">
          OR
        </div>
      </div>
      <button (click)="navigateTo(['auth'])"
        appRipple
        class="border border-primary-300 hover:bg-primary-50 transition-all duration-300 ease-in-out rounded-md flex gap-2 py-3 items-center justify-center text-primary-600"
      >
        <mat-icon>login</mat-icon>
        <div>Sign In With Mikutano Account</div>
      </button>
      <!-- <button
        appRipple
        class="border border-primary-300 hover:bg-primary-50 transition-all duration-300 ease-in-out rounded-md flex gap-2 py-3 items-center justify-center"
      >
        <div>Sign In With LDAP</div>
      </button> -->
      <button
        appRipple
        class="border border-primary-300 hover:bg-primary-50 rounded-md flex gap-2 py-3 items-center justify-center"
      >
        <mat-icon svgIcon="google"></mat-icon>
        <div>Sign In With Google</div>
      </button>
    </div>
  </div>
</div>
